<div class="row">
  <div class="col-7">
    <div class="wheelImage" #wheelImage (mousedown)="startTurnWheel($event)"></div>
    <p class="wheelNote">Drag to turn</p>
  </div>
  <div class="col-5">

    <div class="clue">

      <p>5/8 + 14/16</p>

      <p><input [(ngModel)]="answer" /></p>

      <p><span class="btn btn-primary" (click)="answerButtonPressed()">Answer</span></p>

      <p *ngIf="currentUserService.currentUserData.wheelPuzzleCorrect">Correct!</p>

      <p *ngIf="isIncorrect">Try Again!</p>

    </div>

  </div>
</div>
